// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class DirectMessageBaseClass {
    constructor(code) {
        this.IsDirect = true;
        this.CPHFD = null; // Custom Processing Handler For Delay (return to array)
        this.Code = code;
    }
    Clone() {
        return Object.assign(Object.create(Object.getPrototypeOf(this)), this);
    }
}
